import React from "react";

export default function OnlineStore() {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="OnlineStore">
        <g id="Group">
          <g id="Group_2">
            <g id="Group_3">
              <path
                id="Vector"
                d="M483.388 7.52942H28.6116C16.5646 7.52942 7.5293 16.5647 7.5293 28.6118V483.388C7.5293 495.435 16.5646 504.471 28.6116 504.471H483.388C494.682 504.471 504.47 495.435 504.47 483.388V28.6118C504.47 16.5647 495.435 7.52942 483.388 7.52942V7.52942ZM28.6116 22.5882H483.388C486.4 22.5882 489.412 25.6 489.412 28.6118V111.435H22.5881V28.6118C22.5881 25.6 25.5999 22.5882 28.6116 22.5882V22.5882ZM483.388 489.412H28.6116C25.5999 489.412 22.5881 486.4 22.5881 483.388V126.494H489.412V483.388C489.412 486.4 486.4 489.412 483.388 489.412Z"
                fill="#242424"
              />
            </g>
            <g id="Group_4">
              <path
                id="Vector_2"
                d="M70.7764 98.6352C88.094 98.6352 102.4 84.3294 102.4 67.0117C102.4 49.6941 88.094 35.3882 70.7764 35.3882C53.4587 35.3882 39.1528 48.9411 39.1528 66.2588C39.1528 84.3294 53.4587 98.6352 70.7764 98.6352V98.6352ZM70.7764 49.6941C79.8117 49.6941 87.3411 57.2235 87.3411 66.2588C87.3411 75.2941 79.8117 82.8235 70.7764 82.8235C61.7411 82.8235 54.2117 75.2941 54.2117 66.2588C54.2117 57.2235 61.7411 49.6941 70.7764 49.6941V49.6941Z"
                fill="#242424"
              />
            </g>
            <g id="Group_5">
              <path
                id="Vector_3"
                d="M146.823 98.6352C164.141 98.6352 178.447 84.3294 178.447 67.0117C178.447 49.6941 164.141 35.3882 146.823 35.3882C129.506 35.3882 115.2 49.6941 115.2 67.0117C115.2 84.3294 129.506 98.6352 146.823 98.6352V98.6352ZM146.823 49.6941C155.859 49.6941 163.388 57.2235 163.388 66.2588C163.388 75.2941 155.859 82.8235 146.823 82.8235C137.788 82.8235 130.259 75.2941 130.259 66.2588C130.259 57.2235 137.788 49.6941 146.823 49.6941V49.6941Z"
                fill="#242424"
              />
            </g>
            <g id="Group_6">
              <path
                id="Vector_4"
                d="M223.624 98.6352C240.941 98.6352 255.247 84.3294 255.247 67.0117C255.247 49.6941 240.941 35.3882 223.624 35.3882C206.306 35.3882 192 49.6941 192 67.0117C192 84.3294 205.553 98.6352 223.624 98.6352V98.6352ZM223.624 49.6941C232.659 49.6941 240.188 57.2235 240.188 66.2588C240.188 75.2941 232.659 82.8235 223.624 82.8235C214.588 82.8235 207.059 75.2941 207.059 66.2588C207.059 57.2235 213.835 49.6941 223.624 49.6941V49.6941Z"
                fill="#242424"
              />
            </g>
            <g id="Group_7">
              <path
                id="Vector_5"
                d="M280.847 95.6236H463.059C467.576 95.6236 470.588 92.6118 470.588 88.0942V45.1765C470.588 40.6589 467.576 37.6471 463.059 37.6471H280.847C276.329 37.6471 273.317 40.6589 273.317 45.1765V87.3412C273.317 91.8589 276.329 95.6236 280.847 95.6236V95.6236ZM288.376 52.7059H455.529V79.8118H288.376V52.7059Z"
                fill="#242424"
              />
            </g>
            <g id="Group_8">
              <path
                id="Vector_6"
                d="M338.824 143.059C266.541 143.059 207.059 196.518 207.059 262.024C207.059 287.624 216.847 313.224 234.165 333.553L207.812 387.765C206.306 390.776 207.059 393.788 209.318 396.047C211.576 398.306 214.588 399.059 217.6 397.553L284.612 369.694C301.929 376.471 320 380.235 338.824 380.235C411.106 380.235 470.588 326.776 470.588 261.271C470.588 195.765 411.106 143.059 338.824 143.059V143.059ZM338.824 365.176C321.506 365.176 304.188 361.412 287.624 354.635C286.118 353.882 283.859 353.882 281.6 354.635L229.647 376.471L249.224 335.812C250.729 332.8 249.976 329.788 247.718 327.529C231.153 309.459 221.365 286.118 221.365 262.024C222.118 204.8 274.071 158.118 338.824 158.118C403.576 158.118 455.529 204.8 455.529 262.024C455.529 319.247 402.824 365.176 338.824 365.176V365.176Z"
                fill="#242424"
              />
            </g>
            <g id="Group_9">
              <path
                id="Vector_7"
                d="M407.341 225.129H289.129L283.859 204.8C283.106 201.788 280.094 198.776 276.329 198.776H263.529C259.012 198.776 256 201.788 256 206.306C256 210.823 259.012 213.835 263.529 213.835H271.059L289.882 288.376C290.635 291.388 293.647 294.4 297.412 294.4H393.035C396.8 294.4 399.812 292.141 400.565 289.129L414.871 234.918C415.624 229.647 411.859 225.129 407.341 225.129V225.129ZM387.765 279.341H303.435L293.647 240.188H398.306L387.765 279.341Z"
                fill="#242424"
              />
            </g>
            <g id="Group_10">
              <path
                id="Vector_8"
                d="M377.976 299.671C365.929 299.671 356.894 309.459 356.894 320.753C356.894 332.047 366.682 341.835 377.976 341.835C390.023 341.835 399.059 332.047 399.059 320.753C399.059 309.459 390.023 299.671 377.976 299.671ZM377.976 327.529C374.212 327.529 371.953 324.518 371.953 321.506C371.953 318.494 374.965 315.482 377.976 315.482C380.988 315.482 384 318.494 384 321.506C384 324.518 381.741 327.529 377.976 327.529Z"
                fill="#242424"
              />
            </g>
            <g id="Group_11">
              <path
                id="Vector_9"
                d="M313.976 299.671C301.929 299.671 292.894 309.459 292.894 320.753C292.894 332.047 302.682 341.835 313.976 341.835C325.271 341.835 335.059 332.047 335.059 320.753C335.059 309.459 326.023 299.671 313.976 299.671ZM313.976 327.529C310.212 327.529 307.953 324.518 307.953 321.506C307.953 318.494 310.965 315.482 313.976 315.482C316.988 315.482 320 318.494 320 321.506C320 324.518 317.741 327.529 313.976 327.529Z"
                fill="#242424"
              />
            </g>
            <g id="Group_12">
              <path
                id="Vector_10"
                d="M182.212 335.812H54.9645C50.4468 335.812 47.4351 338.824 47.4351 343.341V460.047C47.4351 464.565 50.4468 467.576 54.9645 467.576H181.459C185.976 467.576 188.988 464.565 188.988 460.047V343.341C189.741 338.824 185.976 335.812 182.212 335.812V335.812ZM174.682 452.518H62.4939V350.871H173.929V452.518H174.682Z"
                fill="#242424"
              />
            </g>
            <g id="Group_13">
              <path
                id="Vector_11"
                d="M185.976 161.882H51.1998C46.6822 161.882 43.6704 164.894 43.6704 169.412C43.6704 173.929 46.6822 176.941 51.1998 176.941H185.976C190.494 176.941 193.506 173.929 193.506 169.412C193.506 164.894 189.741 161.882 185.976 161.882Z"
                fill="#242424"
              />
            </g>
            <g id="Group_14">
              <path
                id="Vector_12"
                d="M185.976 202.541H51.1998C46.6822 202.541 43.6704 205.553 43.6704 210.071C43.6704 214.588 46.6822 217.6 51.1998 217.6H185.976C190.494 217.6 193.506 214.588 193.506 210.071C193.506 205.553 189.741 202.541 185.976 202.541Z"
                fill="#242424"
              />
            </g>
            <g id="Group_15">
              <path
                id="Vector_13"
                d="M185.976 243.2H51.1998C46.6822 243.2 43.6704 246.212 43.6704 250.729C43.6704 255.247 46.6822 258.259 51.1998 258.259H185.976C190.494 258.259 193.506 255.247 193.506 250.729C193.506 246.965 189.741 243.2 185.976 243.2Z"
                fill="#242424"
              />
            </g>
            <g id="Group_16">
              <path
                id="Vector_14"
                d="M185.976 283.859H51.1998C46.6822 283.859 43.6704 286.871 43.6704 291.388C43.6704 295.906 46.6822 298.918 51.1998 298.918H185.976C190.494 298.918 193.506 295.906 193.506 291.388C193.506 286.871 189.741 283.859 185.976 283.859Z"
                fill="#242424"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
